import { Box, makeStyles } from '@material-ui/core';
import { ReactNode } from 'react';
import { InfoBlueIcon } from '../theme/styled-components';

const useStyles = makeStyles((theme) => ({
  infoBox: {
    border: `1px solid ${theme.palette.common.purple}`,
    borderRadius: 5,
    display: 'flex',
    margin: 'auto',
    marginBottom: 20,
    marginTop: 20,
  },
  infoBoxIcon: {
    backgroundColor: theme.palette.common.purple,
    padding: 15,
  },
  infoBoxText: {
    fontSize: 14,
    padding: '15px 20px 15px 15px',
    '& li': {
      marginBottom: 15,
    },
  },
}));

interface InfoBoxProps {
  children: ReactNode;
}

function InfoBox({ children }: InfoBoxProps) {
  const classes = useStyles();

  return (
    <Box className={classes.infoBox}>
      <Box className={classes.infoBoxIcon}>
        <InfoBlueIcon />
      </Box>
      <Box className={classes.infoBoxText}>{children}</Box>
    </Box>
  );
}

export default InfoBox;
